const API_BASE = process.env.REACT_APP_API_BASE_URL || "";
const token = () => localStorage.getItem("token");

export async function listAccountingOrders({
  page = 1,
  pageSize = 50,
  filters = {},
  tkn,
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));

  if (filters.order_from) params.set("order_from", filters.order_from);
  if (filters.order_to) params.set("order_to", filters.order_to);

  if (filters.invoice_from) params.set("invoice_from", filters.invoice_from);
  if (filters.invoice_to) params.set("invoice_to", filters.invoice_to);

  if (filters.fornitore_id) {
    params.set("fornitore_id", String(filters.fornitore_id));
  }

  if (filters.contab_status && filters.contab_status !== "all") {
    params.set("contab_status", filters.contab_status);
  }

  const res = await fetch(
    `${API_BASE}/api/admin/accounting/ordini?${params.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${tkn || token()}`,
      },
      credentials: "include",
    },
  );

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `HTTP ${res.status}`);
  }

  return res.json();
}

export async function markOrdersAsInvoiced(orderIds, { tkn, invoice } = {}) {
  const body = { orderIds };

  if (invoice?.date) body.invoice_date = invoice.date;
  if (invoice?.number != null && String(invoice.number).trim() !== "") {
    body.invoice_number = String(invoice.number).trim();
  }

  const res = await fetch(`${API_BASE}/api/admin/accounting/ordini/fattura`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${tkn || token()}`,
    },
    credentials: "include",
    body: JSON.stringify(body),
  });

  const js = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(js.error || `HTTP ${res.status}`);
  }
  return js;
}

export async function getAccountingSuppliersOptions({ tkn } = {}) {
  const res = await fetch(
    `${API_BASE}/api/admin/accounting/fornitori-options`,
    {
      headers: {
        Authorization: `Bearer ${tkn || token()}`,
      },
      credentials: "include",
    },
  );

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `HTTP ${res.status}`);
  }

  return res.json();
}

export async function listAccountingInvoices({
  page = 1,
  pageSize = 20,
  filters = {},
}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));

  if (filters.year) {
    params.set("year", String(filters.year));
  }
  if (filters.fornitore_id) {
    params.set("fornitore_id", String(filters.fornitore_id));
  }

  const res = await fetch(
    `${API_BASE}/api/admin/accounting/invoices?${params.toString()}`,
    {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
    },
  );

  if (!res.ok) {
    const js = await res.json().catch(() => ({}));
    throw new Error(js.error || `HTTP ${res.status}`);
  }

  return res.json();
}

export async function listAccountingPayables({
  page = 1,
  pageSize = 20,
  filters = {},
}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));

  if (filters.year) {
    params.set("year", String(filters.year));
  }
  if (filters.fornitore_id) {
    params.set("fornitore_id", String(filters.fornitore_id));
  }

  const res = await fetch(
    `${API_BASE}/api/admin/accounting/payables?${params.toString()}`,
    {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
    },
  );

  if (!res.ok) {
    const js = await res.json().catch(() => ({}));
    throw new Error(js.error || `HTTP ${res.status}`);
  }

  return res.json();
}

export async function downloadAccountingInvoicePdf(invoiceId) {
  const res = await fetch(
    `${API_BASE}/api/admin/accounting/invoices/${invoiceId}/pdf`,
    {
      method: "GET",
      credentials: "include",
      headers: token() ? { Authorization: `Bearer ${token()}` } : {},
    },
  );

  if (!res.ok) {
    const js = await res.json().catch(() => ({}));
    throw new Error(js.error || "Errore download PDF fattura");
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);

  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export async function updateAccountingPayableStatus(
  invoiceId,
  { supplier_payment_status, supplier_payment_date },
) {
  const res = await fetch(
    `${API_BASE}/api/admin/accounting/payables/${invoiceId}/payment-status`,
    {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
      body: JSON.stringify({
        supplier_payment_status,
        supplier_payment_date:
          supplier_payment_date === "" ? null : supplier_payment_date,
      }),
    },
  );

  const js = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(js.error || `HTTP ${res.status}`);
  }

  return js;
}

export async function downloadAccountingPayablePdf(invoiceId) {
  const res = await fetch(
    `${API_BASE}/api/admin/accounting/payables/${invoiceId}/pdf`,
    {
      method: "GET",
      credentials: "include",
      headers: token() ? { Authorization: `Bearer ${token()}` } : {},
    },
  );

  if (!res.ok) {
    const js = await res.json().catch(() => ({}));
    throw new Error(js.error || "Errore download PDF liquidazione");
  }

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);

  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export async function listAccountingSubscriptions({
  page = 1,
  pageSize = 50,
  filters = {},
  tkn,
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));

  if (filters.subscription_from) params.set("subscription_from", filters.subscription_from);
  if (filters.subscription_to) params.set("subscription_to", filters.subscription_to);
  if (filters.invoice_from) params.set("invoice_from", filters.invoice_from);
  if (filters.invoice_to) params.set("invoice_to", filters.invoice_to);
  if (filters.fornitore_id) params.set("fornitore_id", String(filters.fornitore_id));
  if (filters.contab_status && filters.contab_status !== "all") {
    params.set("contab_status", filters.contab_status);
  }

  const res = await fetch(
    `${API_BASE}/api/admin/accounting/abbonamenti?${params.toString()}`,
    {
      headers: { Authorization: `Bearer ${tkn || token()}` },
      credentials: "include",
    },
  );

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `HTTP ${res.status}`);
  }

  return res.json();
}

export async function markSubscriptionsAsInvoiced(subscriptionIds, { tkn, invoice } = {}) {
  const body = { subscriptionIds };
  if (invoice?.date) body.invoice_date = invoice.date;
  if (invoice?.number != null && String(invoice.number).trim() !== "") {
    body.invoice_number = String(invoice.number).trim();
  }

  const res = await fetch(`${API_BASE}/api/admin/accounting/abbonamenti/fattura`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${tkn || token()}`,
    },
    credentials: "include",
    body: JSON.stringify(body),
  });

  const js = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(js.error || `HTTP ${res.status}`);
  return js;
}

export async function listSubscriptionPaymentRecords(filters = {}) {
  const params = new URLSearchParams();
  for (const name of ["fornitore_id", "subscription_from", "subscription_to"]) if (filters[name]) params.set(name, filters[name]);
  const res = await fetch(`${API_BASE}/api/admin/accounting/abbonamenti/payments?${params}`, {
    headers: { Authorization: `Bearer ${token()}` }, credentials: "include",
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Errore lettura canoni");
  return data;
}
